const data = {
  piuTariffeOptions: [
    { code: "2.1", description: "Sì" },
    { code: "2.2", description: "No" },
  ],
  compagniaOptions: [
    { code: "4.1" , description: "Afi Esca" },
    { code: "4.2" , description: "AIG Europe" },
    { code: "4.3" , description: "Alleanza Assicurazioni" },
    { code: "4.4" , description: "Allianz" },
    { code: "4.12" , description: "Allianz Viva" },
    { code: "4.6" , description: "Athora Italia" },
    { code: "4.7" , description: "Arca Assicurazioni" },
    { code: "4.8" , description: "Arca Vita" },
    { code: "4.9" , description: "Assimoco" },
    { code: "4.10" , description: "Assimoco Vita" },
    { code: "4.13" , description: "Aviva Vita" },
    { code: "4.14" , description: "AXA France Iard" },
    { code: "4.15" , description: "AXA France Vie" },
    { code: "4.16" , description: "AXA-MPS Assicurazioni Danni" },
    { code: "4.17" , description: "AXA-MPS Assicurazioni Vita" },
    { code: "4.18" , description: "BAP Vita e Previdenza" },
    { code: "4.19" , description: "BCC Assicurazioni" },
    { code: "4.20" , description: "BCC Vita" },
    { code: "4.21" , description: "Banco BPM Assicurazioni" },
    { code: "4.22" , description: "Banco BPM Vita" },
    { code: "4.23" , description: "C.A.C.I. Life" },
    { code: "4.24" , description: "C.A.C.I. Non Life" },
    { code: "4.25" , description: "Cardif Assurance Vie" },
    { code: "4.26" , description: "Cardif Risques Divers" },
    { code: "4.27" , description: "Cardif Vita" },
    { code: "4.28" , description: "CARGEAS Assicurazioni" },
    { code: "4.29" , description: "Cattolica Assicurazioni" },
    { code: "4.30" , description: "CF Assicurazioni" },
    { code: "4.31" , description: "Chiara Assicurazioni" },
    { code: "4.11" , description: "CNP Vita Assicura" },
    { code: "4.32" , description: "CNP Assurances" },
    { code: "4.33" , description: "CNP Caution" },
    { code: "4.34" , description: "UniCredit Life Insurance" },
    { code: "4.35" , description: "Credemassicurazioni" },
    { code: "4.36" , description: "Credemvita" },
    { code: "4.37" , description: "Crédit Agricole Assicurazioni" },
    { code: "4.38" , description: "Crédit Agricole Vita" },
    { code: "4.41" , description: "Eurovita" },
    { code: "4.42" , description: "Generali Italia" },
    { code: "4.43" , description: "Genertel" },
    { code: "4.44" , description: "Genertellife" },
    { code: "4.45" , description: "Global Assistance" },
    { code: "4.46" , description: "Groupama Assicurazioni" },
    { code: "4.47" , description: "HDI Assicurazioni" },
    { code: "4.5" , description: "HDI Italia" },
    { code: "4.48" , description: "Helvetia Assicurazioni" },
    { code: "4.71" , description: "Helvetia Italia Assicurazioni" },
    { code: "4.49" , description: "Helvetia Vita" },
    { code: "4.50" , description: "Incontra Assicurazioni" },
    { code: "4.51" , description: "Intesa Sanpaolo Assicura" },
    { code: "4.73" , description: "Intesa Sanpaolo Assicurazioni" },
    { code: "4.72" , description: "Intesa Sanpaolo Protezione" },
    { code: "4.52" , description: "Intesa Sanpaolo Vita" },
    { code: "4.53" , description: "Italiana Assicurazioni" },
    { code: "4.54" , description: "ITAS Mutua" },
    { code: "4.55" , description: "ITAS Vita" },
    { code: "4.56" , description: "Lombarda Vita" },
    { code: "4.57" , description: "Mediolanum Assicurazioni" },
    { code: "4.58" , description: "Mediolanum Vita" },
    { code: "4.59" , description: "MetLife" },
    { code: "4.60" , description: "Net Insurance" },
    { code: "4.61" , description: "Net Insurance Life" },
    { code: "4.62" , description: "Poste Assicura" },
    { code: "4.63" , description: "Poste Vita" },
    { code: "4.64" , description: "Reale Mutua" },
    { code: "4.65" , description: "SOGESSUR" },
    { code: "4.39" , description: "UniCredit Allianz Assicurazioni" },
    { code: "4.40" , description: "UniCredit Vita Assicurazioni" },
    { code: "4.66" , description: "UnipolSai Assicurazioni" },
    { code: "4.67" , description: "PiùVera Assicurazioni" },
    { code: "4.68" , description: "PiùVera Protezione" },
    { code: "4.69" , description: "Vittoria Assicurazioni" },
    { code: "4.70" , description: "Zurich Insurance" },
    { code: "4.74" , description: "ACM Vie SA" },
    { code: "4.75" , description: "Bene Assicurazioni" },
  ],
  canaleOptions: [
    { code: "5.1", description: "Banca" },
    { code: "5.2", description: "Consulenti Finanziari" },
    { code: "5.3", description: "Agenti" },
    { code: "5.4", description: "Broker" },
    { code: "5.5", description: "Diretto" },
    { code: "5.6", description: "Ente Finanziario" },
  ],
  modDistribuzioneOptions: [
    { code: "7.1", description: "Fisica" },
    { code: "7.2", description: "Online" },
    { code: "7.3", description: "Telemarketing" },
  ],
  mercatoOptions: [
    { code: "8.1", description: "Retail" },
    { code: "8.2", description: "Business" },
  ],
  ramoOptions: [
    { code: "13.1", description: "Vita" },
    { code: "13.2", description: "Danni" },
  ],
  tipologiaGaranzieOptions: [
    { code: "14.1", description: "CPI Mutui" },
    { code: "14.2", description: "CPI Prestiti" },
    { code: "14.3", description: "CPI Leasing" },
    { code: "14.4", description: "CPI Fidi" },
    { code: "14.5", description: "PPI/Income Protection" },
    { code: "14.6", description: "Protezione correntisti" },
  ],
  prodCommercioOptions: [
    { code: "16.1", description: "Sì" },
    { code: "16.2", description: "No" },
  ],
  tipologiaAssicurazioneOptions: [
    { code: "20.1", description: "Individuale" },
    { code: "20.2", description: "Collettiva" },
  ],
  premioTipologiaOptions: [
    { code: "21.1", description: "Annuo" },
    { code: "21.2", description: "Mensile" },
    { code: "21.3", description: "Unico" },
  ],
  frazPremioOptions: [
    { code: "23.1", description: "Mensile" },
    { code: "23.2", description: "Bimestrale" },
    { code: "23.3", description: "Trimestrale" },
    { code: "23.4", description: "Quadrimestrale" },
    { code: "23.5", description: "Semestrale" },
    { code: "23.6", description: "Non previsto" },
  ],
  rischiAssicuratiRamoVitaOptions: [
    { code: "28.1", description: "Decesso (qualsiasi causa)" },
    { code: "28.2", description: "Decesso da infortunio" },
    { code: "28.3", description: "Decesso da malattia" },
    { code: "28.4", description: "Invalidità Permanente (qualsiasi causa)" },
    { code: "28.5", description: "Invalidità Permanente da infortunio" },
    { code: "28.6", description: "Invalidità Permanente da malattia" },
    { code: "28.7", description: "Inabilità Temporanea (qualsiasi causa)" },
    { code: "28.8", description: "Inabilità Temporanea da infortunio" },
    { code: "28.9", description: "Inabilità Temporanea da malattia" },
    { code: "28.10", description: "Malattie gravi" },
    { code: "28.11", description: "Ricovero ospedaliero" },
    { code: "28.12", description: "Ricovero per Grande Intervento Chirurgico" },
    { code: "28.13", description: "Perdita d'impiego" },
    { code: "28.14", description: "Altri rischi" },
  ],
  rischiAssicuratiRamoDanniOptions: [
    { code: "29.1", description: "Decesso (qualsiasi causa)" },
    { code: "29.2", description: "Decesso da infortunio" },
    { code: "29.3", description: "Decesso da malattia" },
    { code: "29.4", description: "Invalidità Permanente (qualsiasi causa)" },
    { code: "29.5", description: "Invalidità Permanente da infortunio" },
    { code: "29.6", description: "Invalidità Permanente da malattia" },
    { code: "29.7", description: "Inabilità Temporanea (qualsiasi causa)" },
    { code: "29.8", description: "Inabilità Temporanea da infortunio" },
    { code: "29.9", description: "Inabilità Temporanea da malattia" },
    { code: "29.10", description: "Malattie gravi" },
    { code: "29.11", description: "Ricovero ospedaliero" },
    { code: "29.12", description: "Ricovero per Grande Intervento Chirurgico" },
    { code: "29.13", description: "Perdita d'impiego" },
    { code: "29.14", description: "Altri rischi" },
  ],
  decessoQualsiasiCausaOptions: [
    { code: "30.1", description: "Garanzia obbligatoria" },
    { code: "30.2", description: "Garanzia facoltativa" },
  ],
  decessoDaInfortunioOptions: [
    { code: "32.1", description: "Garanzia obbligatoria" },
    { code: "32.2", description: "Garanzia facoltativa" },
  ],
  decessoDaMalattiaOptions: [
    { code: "34.1", description: "Garanzia obbligatoria" },
    { code: "34.2", description: "Garanzia facoltativa" },
  ],
  invaliditaPermanenteQualsiasiCausaOptions: [
    { code: "36.1", description: "Garanzia obbligatoria" },
    { code: "36.2", description: "Garanzia facoltativa" },
  ],
  invaliditaPermanenteDaInfortunioOptions: [
    { code: "38.1", description: "Garanzia obbligatoria" },
    { code: "38.2", description: "Garanzia facoltativa" },
  ],
  invaliditaPermanenteDaMalattiaOptions: [
    { code: "40.1", description: "Garanzia obbligatoria" },
    { code: "40.2", description: "Garanzia facoltativa" },
  ],
  inabilitaTemporaneaQualsiasiCausaOptions: [
    { code: "42.1", description: "Garanzia obbligatoria" },
    { code: "42.2", description: "Garanzia facoltativa" },
  ],
  inabilitaTemporaneaDaInfortunioOptions: [
    { code: "44.1", description: "Garanzia obbligatoria" },
    { code: "44.2", description: "Garanzia facoltativa" },
  ],
  inabilitaTemporaneaDaMalattiaOptions: [
    { code: "46.1", description: "Garanzia obbligatoria" },
    { code: "46.2", description: "Garanzia facoltativa" },
  ],
  malattieGraviOptions: [
    { code: "48.1", description: "Garanzia obbligatoria" },
    { code: "48.2", description: "Garanzia facoltativa" },
  ],
  ricoveroOspedalieroOptions: [
    { code: "50.1", description: "Garanzia obbligatoria" },
    { code: "50.2", description: "Garanzia facoltativa" },
  ],
  ricoveroGrandeInterventoChirurgicoOptions: [
    { code: "52.1", description: "Garanzia obbligatoria" },
    { code: "52.2", description: "Garanzia facoltativa" },
  ],
  perditaImpiegoOptions: [
    { code: "54.1", description: "Garanzia obbligatoria" },
    { code: "54.2", description: "Garanzia facoltativa" },
  ],
  yesNoOptions: [
    { code: "true", description: "Sì" },
    { code: "false", description: "No" },
  ],
  rischiAssicuratiOptions: [
    { code: ".1", description: "Decesso (qualsiasi causa)" },
    { code: ".2", description: "Decesso da infortunio" },
    { code: ".3", description: "Decesso da malattia" },
    { code: ".4", description: "Invalidità Permanente (qualsiasi causa)" },
    { code: ".5", description: "Invalidità Permanente da infortunio" },
    { code: ".6", description: "Invalidità Permanente da malattia" },
    { code: ".7", description: "Inabilità Temporanea (qualsiasi causa)" },
    { code: ".8", description: "Inabilità Temporanea da infortunio" },
    { code: ".9", description: "Inabilità Temporanea da malattia" },
    { code: ".10", description: "Malattie gravi" },
    { code: ".11", description: "Ricovero ospedaliero" },
    { code: ".12", description: "Ricovero per Grande Intervento Chirurgico" },
    { code: ".13", description: "Perdita d'impiego" },
    { code: ".14", description: "Altri rischi" },
  ],
};

const selectChoices = {
  piuTariffe: { code: "", description: "" },
  compagnia: [], // multiselect
  canale: [], // multiselect
  modDistribuzione: [], // multiselect
  mercato: [], // multiselect
  ramo: [], // multiselect
  tipologiaGaranzie: [], // multiselect
  prodCommercio: { code: "", description: "" },
  tipologiaAssicurazione: { code: "", description: "" },
  premioTipologia: [], // multiselect
  frazPremio: [], // multiselect
  rischiAssicuratiRamoVita: [], // multiselect
  rischiAssicuratiRamoDanni: [], // multiselect
  decessoQualsiasiCausa: { code: "", description: "" },
  decessoDaInfortunio: { code: "", description: "" },
  decessoDaMalattia: { code: "", description: "" },
  invaliditaPermanenteQualsiasiCausa: { code: "", description: "" },
  invaliditaPermanenteDaInfortunio: { code: "", description: "" },
  invaliditaPermanenteDaMalattia: { code: "", description: "" },
  inabilitaTemporaneaQualsiasiCausa: { code: "", description: "" },
  inabilitaTemporaneaDaInfortunio: { code: "", description: "" },
  inabilitaTemporaneaDaMalattia: { code: "", description: "" },
  malattieGravi: { code: "", description: "" },
  ricoveroOspedaliero: { code: "", description: "" },
  ricoveroGrandeInterventoChirurgico: { code: "", description: "" },
  perditaImpiego: { code: "", description: "" },
};

export { selectChoices };
export default data;
